import React from 'react'
import { useSmartTranslation } from '../generic/hooks/useSmartTranslation'
import { SPECIAL_LABEL_KEY, dayMonthOf, formatOneDecimal, isSpecialBucket } from './loadCapacityFormat'
import MachineDetailSection from './MachineDetailSection'

/**
 * Story 175, CU5 (S92) -- "Utilization ratio per week": one row per element of `weeks`, in the order Sun
 * sent them (BACKLOG first when it comes, rotulated as in the load-capacity block and with no capacity,
 * available or ratio). The same series as `/loadCapacity?deviceId=` (INV-A); every value is painted as
 * it arrived. Without a calendar the capacity figures are "Not available", never "0,0 h" (RN21/INV-E).
 */
const MachineWeeklyTable = ({ weeks, hasCalendar }) => {
  const { t_, i18n } = useSmartTranslation()
  const locale = i18n ? i18n.language : undefined
  const notAvailable = t_('Not available')
  const hours = (value) => `${formatOneDecimal(value, locale)} h`

  return (
    <MachineDetailSection testId='machine-weekly-table' title={t_('Utilization ratio per week')}>
      <div className='mdd__tile'>
        <table className='mdd__table'>
          <thead>
            <tr>
              <th>{t_('Week')}</th>
              <th>{t_('Load (h)')}</th>
              <th>{t_('OEE capacity (h)')}</th>
              <th>{t_('Available')}</th>
              <th>{t_('Ratio')}</th>
            </tr>
          </thead>
          <tbody>
            {weeks.map((bucket) => {
              if (isSpecialBucket(bucket)) {
                return (
                  <tr key={bucket.periodKey} data-testid='machine-weekly-row'>
                    <td>{t_(SPECIAL_LABEL_KEY[bucket.periodType])}</td>
                    <td>{hours(bucket.totalLoadHours)}</td>
                    <td />
                    <td />
                    <td />
                  </tr>
                )
              }
              const ratio = bucket.utilizationRatioPercent
              const isNegative = hasCalendar && bucket.availableCapacityHours < 0
              return (
                <tr key={bucket.periodKey} data-testid='machine-weekly-row'>
                  <td>{`${t_('W{{week}}', { week: bucket.isoWeek })} · ${dayMonthOf(bucket.periodStartDate)}`}</td>
                  <td>{hours(bucket.totalLoadHours)}</td>
                  <td>{hasCalendar ? hours(bucket.oeeCapacityHours) : notAvailable}</td>
                  <td
                    className={isNegative ? 'mdd__negative' : undefined}
                    data-testid='machine-weekly-available'
                    data-negative={isNegative ? 'true' : 'false'}
                  >
                    {hasCalendar ? hours(bucket.availableCapacityHours) : notAvailable}
                  </td>
                  <td>{ratio === null || ratio === undefined ? notAvailable : `${formatOneDecimal(ratio, locale)} %`}</td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    </MachineDetailSection>
  )
}

export default MachineWeeklyTable
